import { render, staticRenderFns, recyclableRender, components } from "./my-membership.vue?vue&type=template&id=3cbcb150&scoped=true&"
var renderjs
import script from "./my-membership.vue?vue&type=script&lang=js&"
export * from "./my-membership.vue?vue&type=script&lang=js&"
import style0 from "./my-membership.vue?vue&type=style&index=0&lang=css&"
import style1 from "./my-membership.vue?vue&type=style&index=1&id=3cbcb150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbcb150",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/my-membership/my-membership.vue"
export default component.exports